import useSession from "hooks/use-session";
import type { JSX } from 'react';
import { FunctionComponent } from "react";

export type UserSession = {
	name: string;
	isAuthenticated: boolean;
};

export type InjectedUserSessionProps = {
	userSession: UserSession
};

export const withUserSession = <T extends object>(Component: FunctionComponent<T & InjectedUserSessionProps>) =>
	(props: T): JSX.Element => {
		const name = useSession.use.name();
		const isAuthenticated = useSession.use.isAuthenticated();

		return <Component {...props} userSession={{ name, isAuthenticated }} />;
	};

export default withUserSession;